import { useEffect } from 'react';
import { handleAnalyticsLinkClick } from '../lib/analytics';

const AnalyticsInteractions = () => {
  useEffect(() => {
    document.addEventListener('click', handleAnalyticsLinkClick);
    return () => document.removeEventListener('click', handleAnalyticsLinkClick);
  }, []);

  return null;
};

export default AnalyticsInteractions;
